var catFilterItems = $('#oxygen-type-filter .dropdown-menu .dropdown-item'),
    resetFilters = $('#filterResetOxygen'),
    paginationHolder = $('.pagination-holder-oxygen');

catFilterItems.on('click', function(e) {
    e.preventDefault();
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
    } else {
        catFilterItems.each(function() {
            $(this).removeClass('active');
        });
        $(this).addClass('active');
        gaSend($(this).data('label'));
    }
    gatherVars();
});

resetFilters.on('click', function() {
    filterReset();
});
$('#oxygen-results').on('click', '#filterResetInlineOxygen', function(e) {
    filterReset();
});

paginationHolder.on('click', 'a', function(e) {
    e.preventDefault();
    if (!$(this).hasClass('is-disabled')) {
        page = $(this).data('p');
        gatherVars(page);
    }
});

function gaSend(label, value = "") {
    if(typeof gtag !== 'undefined') {
        gtag('event', 'click', {
            'event_category': 'Oxygen Mask Filter',
            'event_label': label,
            'value': value
        });
    }
}


function filterReset() {
    catFilterItems.each(function() {
        $(this).removeClass('active');
    });
    triggerFilter();
}

function gatherVars(page = 1) {
    var category, national, state, subCategory, prefiltered;
    
    catFilterItems.each(function() {
        if ($(this).hasClass('active')) {
            category = $(this).data('id');
        }
    });
    triggerFilter(category, page);
}

function tooltipInit() {
    $('[data-toggle="popover"]').popover({
        offset: '0 40',
        trigger: 'hover'
    });

    $(".tooltip-btn").click(function(event) {
        event.preventDefault();
    });
}

if ($('.oxygen-filter-bar').length > 0) {
    gatherVars();
}

function triggerFilter(category = "", page = 1) {
    $.post('/wp-admin/admin-ajax.php', {
        action: "oxygen_filter",
        category: category,
        page: page,
    }).done(function(r) {

        if (r.success) {
            $('#oxygen-results').empty();
            // console.log(r);
            var posts = r.data.posts,
                count = r.data.count,
                pagination = r.data.pagination,
                filteringBy = r.data.filteringBy,
                showReset = r.data.showReset,
                hideMicro = r.data.hideMicro;

            for (var i = 0; i < posts.length; i++) {
                var post = posts[i];
                var html = '<section class="col-sm-6 col-lg-4 col-xxl-3">';
                html += '<a href="' + post.permalink + '" class="card card-media bg-' + post.bgColor + '" ' + post.external + '>';
                html += post.alert;
                html += post.pictureTile;
                html += '<div class="card-body">';
                if (showReset == false && hideMicro == false) {
                    html += '<span class="card-microtitle">';
                    html += post.primaryCat;
                    html += '</span>';
                }
                html += '<h3 class="card-title">';
                html += post.title;
                html += '</h3>';
                html += '</div>';
                html += '<footer class="card-footer media-footer">';
                html += '<p class="micro-title-sm">';
                if (showReset == false && hideMicro == false) {
                    html += post.primaryTag;
                }
                html += '</p>';
                html += '<span class="media-small">';
                html += post.timeAgo;
                html += '</span>';
                html += '</footer>';
                html += '</a>';
                html += '</section>';
                $('#oxygen-results').append(html);
            }
            paginationHolder.html(pagination);
            $('#resource-count').html(count);
            $('#pagination-top .filtering-by').html(filteringBy);

            if (showReset == false) {
                resetFilters.addClass('d-none');
            } else {
                resetFilters.removeClass('d-none');
            }

            tooltipInit();
            if ($('#oxygen-results').hasClass('initial')) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".oxygen-filter-bar").offset().top
                }, 200);
            } else {
                $('#oxygen-results').addClass('initial');
            }


        } else {
            // console.log(r);
            var filteringBy = r.data.filteringBy,
                pagination = r.data.pagination;
            $('#oxygen-results').html('<div class="no-posts"><h2>No resources found</h2><button type="button" class="btn btn-primary btn-red" id="filterResetInlineOxygen" aria-label="Clear filters">Reset Filters</button></div>');
            $('#resource-count').html('0 Resources');
            paginationHolder.html(pagination);
            $('#pagination-top .filtering-by').html(filteringBy);
            if (!subCategory) {
                subFilterHolder.addClass('d-none');
            }
        }
    });

}